// Require

const { id, log, limit, vh } = require("../std/index")

const { Slice } = require("./master")


//
// "Which Casing" Slice
//

module.exports = class RecipeSlice extends Slice {
  constructor($host, config) {
    super($host, config);

    this.stagger = 0.1;

    this.dom.parts = $('.part', $host);

    this.tween = this.prepareTween();
  }

  prepareTween() {
    const tl = new TimelineLite({ paused: true });
    tl.staggerFromTo(this.dom.parts, 0.6, { y: vh(27) }, { y: 0, ease: Power2.easeInOut }, this.stagger);
    return tl;
  }

  onProgress(p) {
    this.tween.seek(p);
  }
};
